import api from '../apiService';
import { API_ROUTES } from '../constants';

export interface PlaybookActionDto {
  actionId?: string;
  playbookId?: string;
  name: string;
  description?: string;
  actionType: string;
  config: Record<string, any>;
  authConfig?: Record<string, any>;
  orderIndex: number;
  enabled: boolean;
}

export interface PlaybookDto {
  playbookId: string;
  tenantId: string;
  name: string;
  description: string;
  entityType: string;
  enabled: boolean;
  createdByUserId?: string;
  createdAt?: string;
  updatedByUserId?: string;
  updatedAt?: string;
  runsCount?: number;
  successCount?: number;
  failedCount?: number;
  actions?: PlaybookActionDto[];
  usersAllowedToEdit?: string[];
  usersAllowedToTrigger?: string[];
  manualTriggeringAllowed?: boolean;
  allowedInApps?: string[];
}

export interface PlaybookCreateDto {
  playbookName: string;
  playbookDescription?: string;
  entityType: string;
  enabled?: boolean;
  manualTriggeringAllowed?: boolean;
  actions?: PlaybookActionDto[];
  usersAllowedToEdit?: string[];
  usersAllowedToTrigger?: string[];
  allowedInApps?: string[];
}

const API_BASE_URL = API_ROUTES.PLAYBOOKS;

export const playbookService = {
  getPlaybooks: async () => {
    const response = await api.get<PlaybookDto[]>(API_BASE_URL);
    return response.data;
  },

  getPlaybookById: async (id: string) => {
    const response = await api.get<PlaybookDto>(`${API_BASE_URL}/${id}`);
    return response.data;
  },

  createPlaybook: async (playbook: PlaybookCreateDto) => {
    const response = await api.post<PlaybookDto>(API_BASE_URL, playbook);
    return response.data;
  },

  updatePlaybook: async (id: string, playbook: Partial<PlaybookDto>) => {
    const response = await api.patch<PlaybookDto>(`${API_BASE_URL}/${id}`, playbook);
    return response.data;
  },

  deletePlaybook: async (id: string) => {
    await api.delete(`${API_BASE_URL}/${id}`);
  },

  executePlaybook: async (playbookId: string, payload: any) => {
    const response = await api.post(`${API_BASE_URL}/${playbookId}/execute`, payload);
    return response.data;
  },

  getExecutionsHistory: async (id: string) => {
    const response = await api.get<any[]>(`${API_BASE_URL}/${id}/${API_ROUTES.EXECUTION_HISTORY}`);
    return response.data;
  },

  getPlaybookAudiLogs: async (playbookId: string) => {
    const response = await api.get(`${API_BASE_URL}/${playbookId}/history`);
    return response.data;
  },
};
